export const view_url_portfolio_home_site = '/'
